import { FORM_FIELD_DATA_TYPE } from "root/libs/core-libs/src/lib/functional";
import { Variants } from "@dhl-official/stencil-library";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

/**
 * Populates `validation` prop for `DhlDropdown` component based on the current state of city and postal code fields.
 *
 * @param {{ section: 'origin'|'destination', isCityRequired: boolean, isPostalCodeRequired: boolean }} props
 */
export const useValidation = ({
  section,
  isCityRequired,
  isPostalCodeRequired,
}) => {
  const intl = useIntl();
  const { city, postalCode } = useSelector(
    (state) => state.tradeLane[section].fields
  );

  const message = intl.formatMessage({
    id: "tradeLaneComponent.cityAndPostalCodeErrorMessage",
  });

  return useMemo(() => {
    if (
      city?.type === FORM_FIELD_DATA_TYPE.PRISTINE ||
      postalCode?.type === FORM_FIELD_DATA_TYPE.PRISTINE
    ) {
      return {};
    }

    if (
      (isCityRequired && city?.type === FORM_FIELD_DATA_TYPE.INVALID) ||
      (isPostalCodeRequired &&
        postalCode?.type === FORM_FIELD_DATA_TYPE.INVALID)
    ) {
      return { type: Variants.invalid, message };
    }

    return { type: Variants.valid };
  }, [city, isCityRequired, isPostalCodeRequired, message, postalCode]);
};
